// @ts-nocheck


import React from 'react';
import Button from 'antd/lib/button';
import Input from 'antd/lib/input';
import styled from 'styled-components';


import { Section } from './../../components/layout';
import Grid, { GridItem } from './../../components/layout/Grid';

import Form from '../../components/Form';

import { Selects } from '../../components';
import CancelButton from '../../components/CancelButton';
import { InputNumber } from '../../components/inputs';

const { YesNoSelect } = Selects;






const InnerForm = ({ onSubmit, multiplier, onCancel }) => {
  return (
    <Form
      onSubmit={onSubmit}
      initialValues={multiplier || { isWinterTime: false }}>

      {(FormField, formikProps) => {
        const {
          handleSubmit,
          handleChange,
          handleBlur,
          setFieldValue,
          dirty,
          isSubmitting
        } = formikProps;
        return (
          <form onSubmit={handleSubmit}>
            <Section>
              <Content>
                <Grid gutter="16px">
                  <GridItem>
                    <FormField label="Наименование" name="name" required>
                      {({ value, name }) =>
                      <Input
                        value={value}
                        name={name}
                        onChange={handleChange}
                        onBlur={handleBlur} />

                      }
                    </FormField>
                  </GridItem>
                  <GridItem>
                    <FormField label="Значение" name="value" required>
                      {({ value, name }) =>
                      <InputNumber
                        value={value}
                        name={name}
                        onChange={(change) => {
                          setFieldValue(name, change);
                        }}
                        step={0.1} />

                      }
                    </FormField>
                  </GridItem>
                  <GridItem>
                    <FormField
                      name="shouldUsedAlways"
                      label="Постоянный коэффициент">

                      {({ value, name }) =>
                      <YesNoSelect
                        value={value}
                        name={name}
                        onBlur={() => handleBlur({ target: { name } })}
                        onChange={(value) =>
                        setFieldValue(name, value)
                        } />

                      }
                    </FormField>
                  </GridItem>
                </Grid>
              </Content>
            </Section>
            <Footer>
              <Button
                disabled={isSubmitting}
                loading={isSubmitting}
                type="primary"
                data-cy="save"
                htmlType="submit">

                Сохранить
              </Button>
              <CancelButton dirty={dirty} onClick={onCancel}>
                Отменить
              </CancelButton>
            </Footer>
          </form>);

      }}
    </Form>);

};

const Content = styled.div.withConfig({ displayName: "InnerForm__Content", componentId: "sc-1nib8tx-0" })(["padding:16px;"]);


const Footer = styled(Section).withConfig({ displayName: "InnerForm__Footer", componentId: "sc-1nib8tx-1" })(["padding:16px;display:flex;justify-content:space-between;align-items:center;"]);






export default InnerForm;
